@if (field) {
  <li (click)="goToQuestion()">{{field.label}}</li>
}
